import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
    Box
} from '@mui/material';

const ConfirmationDialog = ({
    open,
    onClose,
    onConfirm,
    title,
    message,
    confirmText = 'Proceed',
    cancelText = 'Cancel',
    isWarning = false
}) => {
    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle sx={{
                color: isWarning ? '#d32f2f' : '#000000',
                fontWeight: 'bold',
                textAlign: 'center'
            }}>
                {title}
            </DialogTitle>
            <DialogContent>
                <Typography
                    sx={{ textAlign: 'center', fontSize: '17px', mb: 2 }}
                    dangerouslySetInnerHTML={{ __html: message }}
                />
            </DialogContent>
            <DialogActions>
                <Box sx={{
                    display: 'flex',
                    width: '100%',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: 2,
                    mb: 2
                }}>
                    <Button
                        onClick={onClose}
                        variant="outlined"
                        sx={{
                            borderRadius: '20px',
                            minWidth: '120px',
                            fontWeight: 'bold',
                            borderColor: '#757575',
                            color: '#757575',
                        }}
                    >
                        {cancelText}
                    </Button>
                    <Button
                        variant="contained"
                        onClick={onConfirm}
                        sx={{
                            backgroundColor: isWarning ? '#d32f2f' : '#FF6900',
                            borderRadius: '20px',
                            minWidth: 120,
                            '&:hover': {
                                backgroundColor: isWarning ? '#b71c1c' : '#e55357'
                            }
                        }}
                    >
                        {confirmText}
                    </Button>
                </Box>
            </DialogActions>
        </Dialog>
    );
};

export default ConfirmationDialog;

